import { render, staticRenderFns } from "./AssinaturaTermoCompromisso.vue?vue&type=template&id=375b522a&lang=pug"
import script from "./AssinaturaTermoCompromisso.vue?vue&type=script&lang=js"
export * from "./AssinaturaTermoCompromisso.vue?vue&type=script&lang=js"
import style0 from "./AssinaturaTermoCompromisso.vue?vue&type=style&index=0&id=375b522a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports